<template>
  <el-row class='help'>
      <el-col :span="24">
        <div :style="helpImgCss"></div>
      </el-col>
        <el-col :span="24">
            <div class="help-bg1 clear-fix">
                <div class="wh1200">
                    <el-col :span="8">
                        <div class="help-wp1">
                            <span><a href="http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes" target="_blank"><i class="fa fa-qq"></i></a></span>
                            <h3>在线客服</h3>
                            <p>工作时间：8:30-18:00</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="help-wp1">
                            <span><i class="fa fa-phone"></i></span>
                            <h3>0755-82405890</h3>
                            <p>工作时间：8:30-18:00</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="help-wp1">
                            <span><i class="fa fa-commenting"></i></span>
                            <h3>问答专区</h3>
                            <p>小森为您解答</p>
                        </div>
                    </el-col>
                </div>
            </div>
            <div class="help-bg2 clear-fix">
                <div class="wh1200">
                    <div class="help-title1"><span>大家经常搜的</span></div>
                    <ul class="clear-fix help-ul1">
                        <li><router-link to="/helpList/委托业务简介">委托业务简介</router-link></li>
                        <li><router-link to="/helpList/租赁收入列表">租赁收入列表</router-link></li>
                        <li><router-link to="/helpList/租赁业务简介">租赁业务简介</router-link></li>
                        <li><router-link to="/helpList/委托库查询">委托库查询</router-link></li>
                        <li><router-link to="/helpList/维修业务简介">维修业务简介</router-link></li>
                        <li><router-link to="/helpList/维修价格查询">维修价格查询</router-link></li>
                        <li><router-link to="/helpList/物流订单管理">物流订单管理</router-link></li>
                        <li><router-link to="/helpList/发货通知单">发货通知单</router-link></li>
                        <li><router-link to="/helpList/采购询价单">采购询价单</router-link></li>
                        <li><router-link to="/helpList/账户管理">账户管理</router-link></li>
                    </ul>
                    <div class="help-wp2">
                        <el-input placeholder="试试搜索关键词" v-model="helpKeyWords">
                            <el-button @click.native='toHelpList' slot="append"><i class="fa fa-search"></i></el-button>
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="help-bg3 clear-fix">
                <div class="wh1200">
                    <div class="help-title1 help-title2"><span>热门问题</span></div>
                    <div class="help-wp3 clear-fix">
                        <el-row>
                            <el-col :span="12">
                                <div class="help-ask-wp">
                                    <div class="help-ask-q"><span>问</span>合作库为用户提供哪些有价值的服务？</div>
                                    <div class="help-ask-a"><span>答</span>合作库供应链平台为用户提供管家式的服务与适时信息查询（询价、下单、委托、租赁、维修、物流、售后、结算），目地是按帮助用户让业务、运营、管理变得简单、高效、便捷、透明、可控。</div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="help-ask-wp">
                                    <div class="help-ask-q"><span>问</span>合作库如何保证用户信息安全？</div>
                                    <div class="help-ask-a"><span>答</span>合作库网站与数据库分别部署在不同的服务器上，访问权限受到严格控制。云端服务器24小时检测健康状态，且能随时调整服务器配置，保障用户数据安全。</div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="help-ask-wp">
                                    <div class="help-ask-q"><span>问</span>我需要的产品在合作库怎么查不到？</div>
                                    <div class="help-ask-a"><span>答</span>1.选择快速上传您的产品需求给我们；<br/>2.直接在线咨询客服人员。</div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="help-ask-wp">
                                    <div class="help-ask-q"><span>问</span>为什么查不到采购、委托销售/租赁的价格？</div>
                                    <div class="help-ask-a"><span>答</span>采购、销售/租赁价格：因行业价格变化波动频率大，为保证价格和货源的准确性，我们采取的方式是适时回复处理。</div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="help-ask-wp">
                                    <div class="help-ask-q"><span>问</span>配件租赁相比传统采购的成本优势在哪里？</div>
                                    <div class="help-ask-a"><span>答</span>租赁配件可根据实际运营需求调整，相比传统采购在资金投入、库存、运营管理…..整体能帮助用户减少5%或以上的运营成本。</div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="help-ask-wp">
                                    <div class="help-ask-q"><span>问</span>用户有配件需要加入委托销售/租赁需要支付哪些收费？</div>
                                    <div class="help-ask-a"><span>答</span>目前加入委托库都是免费的，用户暂只须支付单次物流费用。平台承担仓储管理、销售运营所产生的费用。</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="help-bg2 clear-fix">
                <div class="wh1200">
                    <div class="help-title1"><span>问题分类</span></div>
                    <div class="help-wp4 clear-fix">
                        <el-row>
                            <el-col :span="6">
                                <div class="text-center help-wp4-ul">
                                    <img src="../../assets/help_icon1.png" alt="委托管理">
                                    <ul class="help-ul2">
                                        <li><router-link to="/helpList/委托管理">委托管理</router-link></li>
                                        <li><router-link to="/helpList/委托业务简介">委托业务简介</router-link></li>
                                        <li><router-link to="/helpList/委托订单列表">委托订单列表</router-link></li>
                                        <li><router-link to="/helpList/租赁收入列表">租赁收入列表</router-link></li>
                                        <li><router-link to="/helpList/出售收入列表">出售收入列表</router-link></li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="text-center help-wp4-ul">
                                    <img src="../../assets/help_icon2.png" alt="租赁管理">
                                    <ul class="help-ul2">
                                        <li><router-link to="/helpList/租赁管理">租赁管理</router-link></li>
                                        <li><router-link to="/helpList/租赁业务简介">租赁业务简介</router-link></li>
                                        <li><router-link to="/helpList/租赁订单查询">租赁订单查询</router-link></li>
                                        <li><router-link to="/helpList/租赁价格查询">租赁价格查询</router-link></li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="text-center help-wp4-ul">
                                    <img src="../../assets/help_icon3.png" alt="库存查询">
                                    <ul class="help-ul2">
                                        <li><router-link to="/helpList/库存查询">库存查询</router-link></li>
                                        <li><router-link to="/helpList/委托库查询">委托库查询</router-link></li>
                                        <li><router-link to="/helpList/代管库查询">代管库查询</router-link></li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="text-center help-wp4-ul">
                                    <img src="../../assets/help_icon4.png" alt="维修查询">
                                    <ul class="help-ul2">
                                        <li><router-link to="/helpList/维修查询">维修查询</router-link></li>
                                        <li><router-link to="/helpList/维修业务简介">维修业务简介</router-link></li>
                                        <li><router-link to="/helpList/维修下单列表">维修下单列表</router-link></li>
                                        <li><router-link to="/helpList/维修价格查询">维修价格查询</router-link></li>
                                    </ul>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <div class="text-center help-wp4-ul">
                                    <img src="../../assets/help_icon5.png" alt="物流信息查询">
                                    <ul class="help-ul2">
                                        <li><router-link to="/helpList/物流信息查询">物流信息查询</router-link></li>
                                        <li><router-link to="/helpList/发货单管理">发货单管理</router-link></li>
                                        <li><router-link to="/helpList/物流订单管理">物流订单管理</router-link></li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="text-center help-wp4-ul">
                                    <img src="../../assets/help_icon6.png" alt="财务查询">
                                    <ul class="help-ul2">
                                        <li><router-link to="/helpList/财务查询">财务查询</router-link></li>
                                        <li><router-link to="/helpList/委托收入报表">委托收入报表</router-link></li>
                                        <li><router-link to="/helpList/委托销售报表">委托销售报表</router-link></li>
                                        <li><router-link to="/helpList/维修支出报表">维修支出报表</router-link></li>
                                        <li><router-link to="/helpList/物流支出报表">物流支出报表</router-link></li>
                                        <li><router-link to="/helpList/保证金报表">保证金报表</router-link></li>
                                        <li><router-link to="/helpList/代管库支出报表">代管库支出报表</router-link></li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="text-center help-wp4-ul">
                                    <img src="../../assets/help_icon7.png" alt="订单管理">
                                    <ul class="help-ul2">
                                        <li><router-link to="/helpList/订单管理">订单管理</router-link></li>
                                        <li><router-link to="/helpList/发货通知单">发货通知单</router-link></li>
                                        <li><router-link to="/helpList/采购询价单">采购询价单</router-link></li>
                                        <li><router-link to="/helpList/委托申请单">委托申请单</router-link></li>
                                        <li><router-link to="/helpList/调度申请单">调度申请单</router-link></li>
                                    </ul>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="text-center help-wp4-ul">
                                    <img src="../../assets/help_icon8.png" alt="个人中心">
                                    <ul class="help-ul2">
                                        <li><router-link to="/helpList/个人中心">个人中心</router-link></li>
                                        <li><router-link to="/helpList/公司信息">公司信息</router-link></li>
                                        <li><router-link to="/helpList/服务网点维护">服务网点维护</router-link></li>
                                        <li><router-link to="/helpList/工程师信息维护">工程师信息维护</router-link></li>
                                        <li><router-link to="/helpList/在线反馈">在线反馈</router-link></li>
                                    </ul>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<script>
export default {
  data() {
    return {
      helpKeyWords: '',
      helpImgCss: {
        background: 'url(' + require('../../assets/help_banner.jpg') + ') no-repeat center top',
        height: '418px',
      },
    }
  },
  methods: {
    toHelpList: function() {
      this.$router.push('/helpList/' + this.helpKeyWords)
    },
  },
}
</script>
<style>
@charset "utf-8";
*{-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;}
.clear-fix:after{clear: both;content: " ";display: block;height: 0;visibility: hidden;font-size: 0;}
.clear{clear: both;}
.fl{float: left;}
.fr{float: right;}
.pt-10,.pt-15,.pt-20,.pt-25,.pt-30{clear: both;}
.pt-5{padding-top: 5px;}
.pt-10{padding-top: 10px;}
.pt-15{padding-top: 15px;}
.pt-20{padding-top: 20px;}
.pt-25{padding-top: 25px;}
.pt-30{padding-top: 30px;}
.pd-10{padding: 10px;}
.pd-15{padding: 15px;}
.pd-20{padding: 20px;}
.text-center{text-align: center;}
.text-right{text-align: right;}
.color-red{color: #ff4e4e;}
.color-green{color: #5FB878;}
.color-blur{color: #00aeef;}
.color-666{color: #666;}
.color-999{color: #999;}

.help.container{width: 100%;}
.wh1200{width: 1200px;margin: 0 auto;position: relative;}
.wh1200:after{clear: both;content: " ";display: block;height: 0;visibility: hidden;font-size: 0;}
.help-bg1{background: #fafafa;padding-bottom: 30px;}
.help-wp1{padding-left: 80px;}
.help-wp1 span{float: left;font-size: 70px;color: #d0d5d9;padding-right: 20px;}
.help-wp1 span a{color: #d0d5d9;}
.help-wp1 h3{padding-top: 17px;font-size: 18px;}
.help-wp1 p{padding-top: 5px;color: #666;}
.help-bg2{background: #fff;}
.help-title1{padding-top: 40px;position: relative;text-align: center;}
.help-title1 span{background: #fff;font-size: 30px;position: relative;z-index: 1;padding: 0 10px;}
.help-title1:after{content: " ";display: block;height: 1px;background: #e1e1e1;position: absolute;bottom: 18px;width: 100%;}
.help-title2 span{background: #4dacc2;color: #fff;}
.help-title2:after{background: #fff;bottom: 14px;}
.help-ul1{padding-top: 40px;padding-bottom: 40px;margin:0 20%;}
.help-ul1 li{float: left;margin: 10px;}
.help-ul1 a{color: #999;background: #fbfbfb;border: solid 1px #ededed;padding: 8px 10px;}
.help-ul1 a:hover{border: solid 1px #00aeef;}
.help-wp2{padding: 30px 30% 80px;}
.help-bg3{background: #4dacc2;}
.help-wp3{padding: 30px 0 100px;}
.help-ask-wp{color: #fff;padding: 60px 5% 0;min-height: 170px;}
.help-ask-wp div{position: relative;padding-left: 40px;line-height: 1.8em;}
.help-ask-wp span{background: #308296;width: 22px;height: 22px;line-height: 22px;border-radius: 3px;text-align: center;font-size: 12px;font-weight: normal;position: absolute;left: 0;top: 2px;z-index: 1;}
.help-ask-a{margin-top: 10px;min-height: 50px;}
.help-ask-a span{background: #F2664B;}
.help-ul2{line-height: 1.8em;}
.help-ul2 li:first-child{font-size: 18px;font-weight: bold;padding-top: 15px;padding-bottom: 5px;}
.help-wp4{padding: 30px 0 80px;}
.help-wp4-ul{padding-top: 30px;}
.help-wp5{border-top: solid 5px gray;background: #fff;border-radius: 4px;}
.help-wp6{padding: 30px 0 20px;}
.help-left1{margin-right: 20px;}
.help-left-wp{padding: 0 10px;}
.help-left-title{padding: 20px 0;font-weight: normal;}
.help-left-ul1 i{padding-right: 10px;}
.help-left-wp .el-collapse-item__content{padding-bottom: 15px;}
.help-left-ul1 li{line-height: 2em;}
.help-wp2-search{padding: 20px 30% 0;}
.help-right1{padding: 20px 10px;line-height: 1.8em;}
.help-right1-title1{font-weight: normal;font-size: 18px;padding-bottom: 10px;border-bottom: solid 1px #ddd;}
.help-right1-title2{font-weight: normal;font-size: 24px;padding-bottom: 10px;border-bottom: solid 1px #ddd;}
.help-right1-title2 span{color: #00aeef;}
.help-right1-title2 strong{font-weight: normal;color: red;}
.help-right1 h4{color: #00aeef;}
.help-wp5-bg{background: #fff;}
.help-no-text{padding-top: 20px;color: #666;line-height: 2em;font-size: 16px;}
.help-qq{padding-top: 30px;padding-left: 20px;}
.help-qq i{padding-right: 10px;}
.help-kf{margin: 30px 0;text-align: center;}
.help-kf span{vertical-align: top;}
.help-kf-left{border-right: solid 1px #ddd;}
.help-phone{font-size: 30px;padding-top: 38px;}
.help-fixed{width: 230px;padding: 10px;background: #fff;top: 0;}
.table-01{margin: 10px 0;}
.table-01 th{background: #F2F2F2;}
.table-01 td,.table-01 th{border: solid 1px #ddd;padding: 5px;}
.help-pd{padding: 10px 0;}
.help-search-wp{background: #dcebf6;padding-bottom: 20px;}
</style>




// WEBPACK FOOTER //
// Help.vue?6e1aa282